module.exports = __webpack_public_path__ + "assets/img/5.7360883c.jpg";